// Contenu juridique trilingue (FR / Darija-AR / EN) — Conformité à la loi marocaine
// sur la copropriété : loi 18-00, complétée par 106-12 (2016) et modernisée par 30-24 (2024).
// Sources : texte officiel (adala.justice.gov.ma), synthèses juridiques marocaines.
// NB : contenu informatif, ne remplace pas un notaire / adoul / avocat.

export const LEGAL_CONTENT = {
  fr: {
    ui: {
      title: "Cadre légal & Conformité",
      sub: "Copropriété au Maroc — lois 18-00, 106-12 et 30-24",
      intro_title: "Le cadre légal marocain",
      laws_title: "Les textes de loi",
      syndic_title: "Obligations légales du syndic",
      ag_title: "L'assemblée générale (AG)",
      majorities_title: "Quorum et majorités de vote",
      conseil_title: "Le conseil syndical",
      reglement_title: "Le règlement de copropriété",
      conciliation_title: "Conciliation préalable obligatoire (loi 30-24)",
      checklist_title: "Checklist de conformité",
      contacts_title: "Contacts légaux utiles",
      contacts_sub: "À compléter par le président",
      disclaimer_title: "Avertissement",
      reglement_doc_title: "Modèle de règlement de copropriété (conforme)",
      reglement_doc_sub: "Texte adapté à Rahma Bat A — modifiable puis publiable",
      publish_btn: "Publier dans Documents",
      published_ok: "Règlement publié dans Documents",
      edit_contacts: "Modifier les contacts",
      save_contacts: "Enregistrer",
      empty_contacts: "Aucun contact renseigné. Le président peut les ajouter.",
      tribunal: "Tribunal de première instance",
      adoul: "Adoul (notaire traditionnel)",
      notaire: "Notaire",
      avocat: "Avocat",
      name_ph: "Nom / intitulé",
      phone_ph: "Téléphone",
      address_ph: "Adresse",
      note_ph: "Note (facultatif)",
      show_reglement: "Voir le texte du règlement",
      hide_reglement: "Masquer le texte",
    },
    intro: [
      "La copropriété au Maroc est régie par la loi n° 18-00 relative au statut de la copropriété des immeubles bâtis, complétée par la loi 106-12 (2016) et modernisée par la loi 30-24 (adoptée à l'unanimité le 9 juillet 2024).",
      "Tous les copropriétaires sont regroupés de plein droit dans un syndicat des copropriétaires, doté de la personnalité morale et de l'autonomie financière. Son objet : la conservation de l'immeuble et l'administration des parties communes.",
      "Le syndicat est administré par l'assemblée générale (organe de décision) et géré par un syndic (organe exécutif), assisté d'un conseil syndical.",
    ],
    laws: [
      {
        code: "Loi 18-00", year: "2002", title: "Statut de la copropriété des immeubles bâtis",
        points: [
          "Texte fondateur : définit la copropriété, les parties privatives et communes, les tantièmes (quotes-parts).",
          "Rend le règlement de copropriété obligatoire.",
          "Institue le syndicat des copropriétaires, l'assemblée générale et le syndic.",
        ],
      },
      {
        code: "Loi 106-12", year: "2016", title: "Réforme de la loi 18-00",
        points: [
          "Renforce le rôle du conseil syndical (obligatoire dans certaines copropriétés).",
          "Encadre le syndic : contrat, durée du mandat, révocation ; distinction bénévole / professionnel.",
          "Précise la procédure d'AG : convocation, quorum, procurations, publicité des décisions.",
          "Introduit une logique de provision (fonds) pour les travaux futurs.",
        ],
      },
      {
        code: "Loi 30-24", year: "2024", title: "Modernisation de la copropriété",
        points: [
          "Conciliation préalable OBLIGATOIRE avant toute action en justice du syndic (sinon action irrecevable).",
          "Notification des décisions d'AG à TOUS les copropriétaires dans un délai de 8 jours (avec le procès-verbal).",
          "Un ou plusieurs copropriétaires peuvent convoquer l'AG (par tout moyen légal ou par huissier), préavis de 15 jours.",
          "Objectif : plus de transparence et déblocage des copropriétés en cas de syndic défaillant.",
        ],
      },
    ],
    syndic: [
      "Exécuter le règlement de copropriété et les décisions de l'assemblée générale.",
      "Administrer l'immeuble, assurer sa conservation, sa garde et son entretien.",
      "Établir le budget prévisionnel et le soumettre au vote de l'AG.",
      "Tenir la comptabilité du syndicat (fonds séparés, compte dédié) et la présenter.",
      "Convoquer l'assemblée générale, préparer l'ordre du jour et communiquer les procès-verbaux.",
      "Représenter le syndicat dans les actes civils et en justice.",
      "Percevoir les charges, suivre les impayés et organiser le recouvrement (après conciliation).",
      "Conserver les documents du syndicat et remettre le dossier complet à son successeur.",
    ],
    ag: [
      "L'assemblée générale est l'organe souverain de la copropriété.",
      "Une AG ordinaire doit se tenir au moins une fois par an pour approuver les comptes et voter le budget.",
      "La convocation est envoyée au moins 15 jours avant la réunion : date, heure, lieu et ordre du jour.",
      "Les décisions sont notifiées à tous les copropriétaires dans les 8 jours (procès-verbal joint).",
      "Depuis la loi 30-24, un ou plusieurs copropriétaires peuvent eux-mêmes convoquer l'AG si nécessaire.",
    ],
    majorities: [
      { level: "Majorité absolue", desc: "Gestion courante de l'immeuble et application du règlement de copropriété (voix des présents ou représentés)." },
      { level: "Majorité des 3/4", desc: "Élaboration ou modification du règlement, travaux d'amélioration, désignation ou révocation du syndic, révision de la répartition des charges." },
      { level: "Unanimité", desc: "Décisions touchant la consistance de l'immeuble : nouveaux bâtiments, cession de parties communes, transformation communes→privatives, surélévation, excavation, démolition totale." },
    ],
    quorum_note: "Quorum : au moins la moitié des copropriétaires (présents ou représentés). À défaut, une seconde AG peut se tenir dans les 30 jours et délibérer sans condition de quorum.",
    conseil: "Le conseil syndical assiste le syndic et contrôle sa gestion. Il fait le lien entre les copropriétaires et le syndic, donne son avis sur les questions de la copropriété et peut consulter tous les documents. Son rôle a été renforcé par la loi 106-12.",
    reglement: [
      "Le règlement de copropriété est OBLIGATOIRE pour tout immeuble en copropriété.",
      "Il fixe la destination de l'immeuble et des parties privatives et communes.",
      "Il définit les conditions d'usage des parties privatives et communes.",
      "Il fixe les règles d'administration des parties communes.",
      "Il détermine la quote-part (tantièmes) de chaque lot et la répartition des charges.",
      "Il sert de base au calcul des voix en assemblée générale.",
    ],
    conciliation: [
      "Depuis la loi 30-24, une tentative de conciliation formelle et documentée est OBLIGATOIRE avant toute action en justice du syndic.",
      "Sans cette étape, l'action judiciaire est déclarée irrecevable par le tribunal.",
      "Sont notamment concernés : charges impayées, travaux non autorisés, usage abusif des parties communes, violations du règlement.",
    ],
    checklist: [
      "Un règlement de copropriété écrit existe et est accessible à tous les copropriétaires.",
      "Une assemblée générale ordinaire est tenue au moins une fois par an.",
      "Les convocations d'AG sont envoyées au moins 15 jours à l'avance avec l'ordre du jour.",
      "Les procès-verbaux d'AG sont notifiés à tous dans les 8 jours.",
      "Un syndic est désigné par l'AG et un conseil syndical est en place.",
      "La comptabilité est tenue de façon transparente (compte dédié, justificatifs).",
      "Les tantièmes (quotes-parts) de chaque lot sont définis et connus.",
      "Une tentative de conciliation est menée avant tout recours judiciaire.",
    ],
    disclaimer: "Ces informations sont fournies à titre pédagogique pour faciliter la conformité de la copropriété « Rahma Bat A ». Elles ne constituent pas un avis juridique et ne remplacent pas la consultation d'un notaire, d'un adoul ou d'un avocat. En cas de doute, référez-vous au texte officiel des lois 18-00, 106-12 et 30-24 et consultez un professionnel du droit.",
    reglementTemplate: {
      title: "Règlement de copropriété — Rahma Bat A",
      body: `RÈGLEMENT DE COPROPRIÉTÉ
Immeuble « Rahma Bat A » — 34 Avenue Meki Naciri, Tétouan
Établi conformément à la loi n° 18-00 relative au statut de la copropriété des immeubles bâtis, telle que modifiée et complétée par les lois 106-12 et 30-24.

TITRE I — DÉSIGNATION
Article 1 — L'immeuble « Rahma Bat A » est composé de 11 logements (9 duplex et 2 appartements) répartis sur plusieurs étages et desservis par un ascenseur.
Article 2 — Parties communes : le hall d'entrée, la cage d'escalier, les paliers, l'ascenseur, la terrasse (stah / toit) et la loge du gardien, à l'usage de tous les copropriétaires.
Article 3 — Parties privatives : chaque logement (lot) appartient en propriété exclusive à son copropriétaire.

TITRE II — DESTINATION
Article 4 — L'immeuble est à usage principal d'habitation. Tout changement de destination d'un lot doit respecter la loi et ne pas nuire à la tranquillité de l'immeuble.

TITRE III — QUOTES-PARTS (TANTIÈMES) ET CHARGES
Article 5 — À chaque lot est affectée une quote-part des parties communes (tantièmes), qui détermine le poids de vote en assemblée générale et la répartition des charges. Les tantièmes de chaque lot sont annexés au présent règlement.
Article 6 — Particularité de Rahma Bat A : les charges courantes de l'immeuble sont couvertes par le loyer trimestriel versé par l'opérateur de l'antenne relais installée sur la terrasse. Les copropriétaires ne versent donc pas de cotisation ordinaire, sauf décision contraire de l'assemblée générale (travaux exceptionnels, insuffisance de recettes).
Article 7 — Toute dépense est publiée en temps réel dans le fil de transparence de l'application.

TITRE IV — ADMINISTRATION
Article 8 — Les copropriétaires sont groupés dans un syndicat des copropriétaires doté de la personnalité morale, ayant pour objet la conservation de l'immeuble et l'administration des parties communes.
Article 9 — Le syndicat est administré par l'assemblée générale et géré par un syndic élu, assisté d'un conseil syndical.

TITRE V — ASSEMBLÉE GÉNÉRALE
Article 10 — L'assemblée générale ordinaire se réunit au moins une fois par an pour approuver les comptes et voter le budget.
Article 11 — La convocation est adressée au moins 15 jours à l'avance et mentionne la date, l'heure, le lieu et l'ordre du jour.
Article 12 — Le quorum est atteint lorsque la moitié au moins des copropriétaires est présente ou représentée. À défaut, une seconde assemblée se tient dans les 30 jours et délibère sans condition de quorum.
Article 13 — Les décisions sont prises : à la majorité absolue pour la gestion courante ; à la majorité des trois quarts pour la modification du règlement, les travaux d'amélioration et la désignation ou révocation du syndic ; à l'unanimité pour les décisions touchant à la consistance de l'immeuble.
Article 14 — Les décisions de l'assemblée sont notifiées à tous les copropriétaires dans un délai de 8 jours, procès-verbal à l'appui.

TITRE VI — SYNDIC ET CONSEIL SYNDICAL
Article 15 — Le syndic exécute le règlement et les décisions de l'AG, administre et entretient l'immeuble, tient la comptabilité, convoque l'AG et représente le syndicat.
Article 16 — Le conseil syndical assiste et contrôle le syndic et fait le lien avec les copropriétaires.

TITRE VII — LITIGES ET CONCILIATION
Article 17 — Conformément à la loi 30-24, toute action en justice du syndic doit être précédée d'une tentative de conciliation formelle et documentée ; à défaut, l'action est irrecevable.

TITRE VIII — DISPOSITIONS DIVERSES
Article 18 — Chacun veille à la tranquillité, à la propreté et à la sécurité de l'immeuble.
Article 19 — Le présent règlement s'impose à tous les copropriétaires, locataires et occupants.

Adopté par l'assemblée générale du ____ / ____ / ________.
Le Président (syndic) : ____________________`,
    },
  },

  ar: {
    ui: {
      title: "الإطار القانوني والامتثال",
      sub: "الملكية المشتركة بالمغرب — قوانين 18.00 و106.12 و30.24",
      intro_title: "الإطار القانوني المغربي",
      laws_title: "النصوص القانونية",
      syndic_title: "الالتزامات القانونية للمتصرف (السانديك)",
      ag_title: "الجمع العام",
      majorities_title: "النصاب وأغلبيات التصويت",
      conseil_title: "المجلس النقابي",
      reglement_title: "نظام الملكية المشتركة",
      conciliation_title: "محاولة الصلح الإجبارية (قانون 30.24)",
      checklist_title: "لائحة التحقق من الامتثال",
      contacts_title: "جهات اتصال قانونية مفيدة",
      contacts_sub: "يملؤها الرئيس",
      disclaimer_title: "تنبيه",
      reglement_doc_title: "نموذج نظام الملكية المشتركة (مطابق للقانون)",
      reglement_doc_sub: "نص مُكيّف مع رحمة بلوك A — قابل للتعديل ثم النشر",
      publish_btn: "نشر في الوثائق",
      published_ok: "تم نشر النظام في الوثائق",
      edit_contacts: "تعديل جهات الاتصال",
      save_contacts: "حفظ",
      empty_contacts: "لا توجد جهات اتصال. يمكن للرئيس إضافتها.",
      tribunal: "المحكمة الابتدائية",
      adoul: "العدول (الموثق التقليدي)",
      notaire: "الموثق",
      avocat: "المحامي",
      name_ph: "الاسم / التسمية",
      phone_ph: "الهاتف",
      address_ph: "العنوان",
      note_ph: "ملاحظة (اختياري)",
      show_reglement: "عرض نص النظام",
      hide_reglement: "إخفاء النص",
    },
    intro: [
      "تخضع الملكية المشتركة بالمغرب للقانون رقم 18.00 المتعلق بنظام الملكية المشتركة للعقارات المبنية، المتمم بالقانون 106.12 (2016) والمُحدَّث بالقانون 30.24 (المصادق عليه بالإجماع في 9 يوليوز 2024).",
      "يُجمَّع جميع الملاك بقوة القانون في اتحاد للملاك المشتركين يتمتع بالشخصية المعنوية والاستقلال المالي، هدفه المحافظة على العقار وتدبير الأجزاء المشتركة.",
      "يُدار الاتحاد من طرف الجمع العام (جهاز التقرير) ويُسيَّر من طرف متصرف (جهاز تنفيذي) يساعده مجلس نقابي.",
    ],
    laws: [
      {
        code: "قانون 18.00", year: "2002", title: "نظام الملكية المشتركة للعقارات المبنية",
        points: [
          "النص المؤسس: يعرّف الملكية المشتركة والأجزاء الخاصة والمشتركة والأنصبة (الحصص).",
          "يجعل نظام الملكية المشتركة إلزاميًا.",
          "يُحدث اتحاد الملاك والجمع العام والمتصرف.",
        ],
      },
      {
        code: "قانون 106.12", year: "2016", title: "إصلاح القانون 18.00",
        points: [
          "يعزز دور المجلس النقابي (إلزامي في بعض الملكيات المشتركة).",
          "يؤطّر المتصرف: العقد ومدة الانتداب والعزل؛ التمييز بين المتصرف المتطوع والمهني.",
          "يوضّح مسطرة الجمع العام: الاستدعاء والنصاب والوكالات ونشر القرارات.",
          "يُدخل منطق تخصيص احتياطي (صندوق) للأشغال المستقبلية.",
        ],
      },
      {
        code: "قانون 30.24", year: "2024", title: "تحديث الملكية المشتركة",
        points: [
          "محاولة صلح إجبارية قبل أي دعوى قضائية يرفعها المتصرف (وإلا كانت الدعوى غير مقبولة).",
          "تبليغ قرارات الجمع العام لجميع الملاك داخل أجل 8 أيام (مرفقة بالمحضر).",
          "يمكن لمالك أو أكثر استدعاء الجمع العام (بأي وسيلة قانونية أو عبر مفوض قضائي) بإشعار مسبق مدته 15 يومًا.",
          "الهدف: مزيد من الشفافية وفكّ العرقلة عند تقصير المتصرف.",
        ],
      },
    ],
    syndic: [
      "تنفيذ نظام الملكية المشتركة وقرارات الجمع العام.",
      "تدبير العقار وضمان المحافظة عليه وحراسته وصيانته.",
      "إعداد الميزانية التقديرية وعرضها على تصويت الجمع العام.",
      "مسك محاسبة الاتحاد (أموال منفصلة، حساب خاص) وتقديمها.",
      "استدعاء الجمع العام وإعداد جدول الأعمال وتبليغ المحاضر.",
      "تمثيل الاتحاد في التصرفات المدنية وأمام القضاء.",
      "تحصيل الواجبات وتتبع المتأخرات وتنظيم الاستخلاص (بعد الصلح).",
      "حفظ وثائق الاتحاد وتسليم الملف الكامل لخلفه.",
    ],
    ag: [
      "الجمع العام هو الجهاز السيادي للملكية المشتركة.",
      "يجب عقد جمع عام عادي مرة واحدة على الأقل في السنة للمصادقة على الحسابات والتصويت على الميزانية.",
      "يُوجَّه الاستدعاء 15 يومًا على الأقل قبل الاجتماع: التاريخ والساعة والمكان وجدول الأعمال.",
      "تُبلَّغ القرارات لجميع الملاك داخل أجل 8 أيام (مرفقة بالمحضر).",
      "منذ قانون 30.24، يمكن لمالك أو أكثر استدعاء الجمع العام عند الاقتضاء.",
    ],
    majorities: [
      { level: "الأغلبية المطلقة", desc: "التدبير الجاري للعقار وتطبيق نظام الملكية المشتركة (أصوات الحاضرين أو الممثَّلين)." },
      { level: "أغلبية ثلاثة أرباع", desc: "وضع أو تعديل النظام، أشغال التحسين، تعيين أو عزل المتصرف، ومراجعة توزيع الأعباء." },
      { level: "الإجماع", desc: "القرارات المتعلقة بقوام العقار: بناء عمارات جديدة، التفويت في أجزاء مشتركة، تحويل المشترك إلى خاص، التعلية، الحفر، أو الهدم الكلي." },
    ],
    quorum_note: "النصاب: نصف الملاك على الأقل (حاضرين أو ممثَّلين). وإلا، يمكن عقد جمع عام ثانٍ داخل 30 يومًا يتداول دون شرط النصاب.",
    conseil: "يساعد المجلس النقابي المتصرف ويراقب تدبيره. يربط بين الملاك والمتصرف، ويبدي رأيه في قضايا الملكية المشتركة، ويمكنه الاطلاع على جميع الوثائق. عُزِّز دوره بموجب القانون 106.12.",
    reglement: [
      "نظام الملكية المشتركة إلزامي لكل عقار خاضع للملكية المشتركة.",
      "يحدد وجهة استعمال العقار والأجزاء الخاصة والمشتركة.",
      "يضبط شروط استعمال الأجزاء الخاصة والمشتركة.",
      "يحدد قواعد تدبير الأجزاء المشتركة.",
      "يحدد حصة (أنصبة) كل جزء وتوزيع الأعباء.",
      "يُعتمد أساسًا لاحتساب الأصوات في الجمع العام.",
    ],
    conciliation: [
      "منذ قانون 30.24، أصبحت محاولة الصلح الرسمية والموثقة إجبارية قبل أي دعوى قضائية يرفعها المتصرف.",
      "بدون هذه المرحلة، تُصرّح المحكمة بعدم قبول الدعوى.",
      "تشمل خصوصًا: الواجبات غير المؤداة، الأشغال غير المرخصة، الاستعمال التعسفي للأجزاء المشتركة، وخرق النظام.",
    ],
    checklist: [
      "وجود نظام ملكية مشتركة مكتوب ومتاح لجميع الملاك.",
      "عقد جمع عام عادي مرة واحدة على الأقل في السنة.",
      "توجيه الاستدعاءات 15 يومًا على الأقل قبل الموعد مع جدول الأعمال.",
      "تبليغ محاضر الجمع العام للجميع داخل 8 أيام.",
      "تعيين متصرف من طرف الجمع العام ووجود مجلس نقابي.",
      "مسك المحاسبة بشفافية (حساب خاص، وثائق مثبتة).",
      "تحديد أنصبة (حصص) كل جزء ومعرفتها.",
      "إجراء محاولة صلح قبل أي لجوء إلى القضاء.",
    ],
    disclaimer: "تُقدَّم هذه المعلومات لأغراض تعليمية لتيسير امتثال الملكية المشتركة «رحمة بلوك A». وهي لا تُعدّ استشارة قانونية ولا تغني عن استشارة موثق أو عدل أو محامٍ. عند الشك، ارجع إلى النص الرسمي للقوانين 18.00 و106.12 و30.24 واستشر مختصًا في القانون.",
    reglementTemplate: {
      title: "نظام الملكية المشتركة — رحمة بلوك A",
      body: `نظام الملكية المشتركة
عمارة «رحمة بلوك A» — 34 شارع مكي الناصري، تطوان
مُعدّ وفقًا للقانون رقم 18.00 المتعلق بنظام الملكية المشتركة للعقارات المبنية، كما تم تعديله وتتميمه بالقانونين 106.12 و30.24.

الباب الأول — التعيين
المادة 1 — تتكون عمارة «رحمة بلوك A» من 11 مسكنًا (9 دوبلكس ومسكنان) موزعة على عدة طوابق ومزودة بمصعد.
المادة 2 — الأجزاء المشتركة: البهو، بيت الدرج، البسطات، المصعد، السطح (الستاح)، وبيت الحارس، لاستعمال جميع الملاك.
المادة 3 — الأجزاء الخاصة: كل مسكن (جزء) ملك خالص لصاحبه.

الباب الثاني — الوجهة
المادة 4 — العمارة معدّة أساسًا للسكن. كل تغيير لوجهة جزء يجب أن يحترم القانون وألا يمسّ بهدوء العمارة.

الباب الثالث — الأنصبة (الحصص) والأعباء
المادة 5 — يُخصَّص لكل جزء نصيب من الأجزاء المشتركة (الأنصبة) يحدد وزن التصويت في الجمع العام وتوزيع الأعباء. تُلحق أنصبة كل جزء بهذا النظام.
المادة 6 — خصوصية رحمة بلوك A: تُغطّى الأعباء الجارية للعمارة من الكراء الفصلي الذي يؤديه مشغّل الهوائي المُركَّب على السطح. لا يؤدي الملاك واجبًا عاديًا، إلا بقرار مخالف من الجمع العام (أشغال استثنائية، نقص المداخيل).
المادة 7 — تُنشر كل نفقة في الوقت الفعلي ضمن سجل الشفافية بالتطبيق.

الباب الرابع — التدبير
المادة 8 — يُجمَّع الملاك في اتحاد للملاك المشتركين يتمتع بالشخصية المعنوية، هدفه المحافظة على العقار وتدبير الأجزاء المشتركة.
المادة 9 — يُدار الاتحاد من طرف الجمع العام ويُسيَّر من طرف متصرف منتخب يساعده مجلس نقابي.

الباب الخامس — الجمع العام
المادة 10 — يجتمع الجمع العام العادي مرة واحدة على الأقل في السنة للمصادقة على الحسابات والتصويت على الميزانية.
المادة 11 — يُوجَّه الاستدعاء 15 يومًا على الأقل قبل الموعد ويتضمن التاريخ والساعة والمكان وجدول الأعمال.
المادة 12 — يتحقق النصاب بحضور أو تمثيل نصف الملاك على الأقل. وإلا، يُعقد جمع ثانٍ داخل 30 يومًا يتداول دون شرط النصاب.
المادة 13 — تُتخذ القرارات: بالأغلبية المطلقة للتدبير الجاري؛ وبأغلبية ثلاثة أرباع لتعديل النظام وأشغال التحسين وتعيين أو عزل المتصرف؛ وبالإجماع للقرارات المتعلقة بقوام العقار.
المادة 14 — تُبلَّغ قرارات الجمع لجميع الملاك داخل أجل 8 أيام مرفقة بالمحضر.

الباب السادس — المتصرف والمجلس النقابي
المادة 15 — ينفذ المتصرف النظام وقرارات الجمع العام، ويدبّر العمارة ويصونها، ويمسك المحاسبة، ويستدعي الجمع العام، ويمثل الاتحاد.
المادة 16 — يساعد المجلس النقابي المتصرف ويراقبه ويربط مع الملاك.

الباب السابع — النزاعات والصلح
المادة 17 — طبقًا للقانون 30.24، يجب أن تسبق كل دعوى قضائية للمتصرف محاولةُ صلح رسمية وموثقة؛ وإلا كانت الدعوى غير مقبولة.

الباب الثامن — أحكام مختلفة
المادة 18 — يسهر الجميع على هدوء العمارة ونظافتها وسلامتها.
المادة 19 — يُلزِم هذا النظام جميع الملاك والمكترين والشاغلين.

مصادق عليه من طرف الجمع العام بتاريخ ____ / ____ / ________.
الرئيس (المتصرف): ____________________`,
    },
  },

  en: {
    ui: {
      title: "Legal Framework & Compliance",
      sub: "Co-ownership in Morocco — laws 18-00, 106-12 and 30-24",
      intro_title: "The Moroccan legal framework",
      laws_title: "The laws",
      syndic_title: "Legal duties of the syndic (manager)",
      ag_title: "The general assembly (GA)",
      majorities_title: "Quorum and voting majorities",
      conseil_title: "The syndical council",
      reglement_title: "The co-ownership regulations",
      conciliation_title: "Mandatory prior conciliation (law 30-24)",
      checklist_title: "Compliance checklist",
      contacts_title: "Useful legal contacts",
      contacts_sub: "To be filled in by the president",
      disclaimer_title: "Disclaimer",
      reglement_doc_title: "Co-ownership regulations template (compliant)",
      reglement_doc_sub: "Text adapted to Rahma Bat A — editable then publishable",
      publish_btn: "Publish to Documents",
      published_ok: "Regulations published to Documents",
      edit_contacts: "Edit contacts",
      save_contacts: "Save",
      empty_contacts: "No contact yet. The president can add them.",
      tribunal: "Court of first instance",
      adoul: "Adoul (traditional notary)",
      notaire: "Notary",
      avocat: "Lawyer",
      name_ph: "Name / title",
      phone_ph: "Phone",
      address_ph: "Address",
      note_ph: "Note (optional)",
      show_reglement: "Show the regulations text",
      hide_reglement: "Hide the text",
    },
    intro: [
      "Co-ownership in Morocco is governed by law No. 18-00 on the status of co-ownership of built properties, supplemented by law 106-12 (2016) and modernized by law 30-24 (adopted unanimously on 9 July 2024).",
      "All co-owners are automatically grouped into a co-owners' union with legal personality and financial autonomy. Its purpose: preserving the building and administering the common areas.",
      "The union is administered by the general assembly (decision body) and managed by a syndic (executive body), assisted by a syndical council.",
    ],
    laws: [
      {
        code: "Law 18-00", year: "2002", title: "Status of co-ownership of built properties",
        points: [
          "Founding text: defines co-ownership, private and common areas, and shares (tantièmes).",
          "Makes the co-ownership regulations mandatory.",
          "Establishes the co-owners' union, the general assembly and the syndic.",
        ],
      },
      {
        code: "Law 106-12", year: "2016", title: "Reform of law 18-00",
        points: [
          "Strengthens the syndical council (mandatory in some co-ownerships).",
          "Frames the syndic: contract, term, revocation; volunteer vs professional distinction.",
          "Clarifies GA procedure: notice, quorum, proxies, publication of decisions.",
          "Introduces a provision (fund) for future works.",
        ],
      },
      {
        code: "Law 30-24", year: "2024", title: "Modernization of co-ownership",
        points: [
          "MANDATORY prior conciliation before any legal action by the syndic (otherwise the action is inadmissible).",
          "Notification of GA decisions to ALL co-owners within 8 days (with the minutes).",
          "One or more co-owners may convene the GA (by any legal means or via a bailiff), with 15 days' notice.",
          "Goal: more transparency and unblocking co-ownerships when the syndic fails.",
        ],
      },
    ],
    syndic: [
      "Enforce the co-ownership regulations and the general assembly's decisions.",
      "Administer the building and ensure its preservation, safekeeping and maintenance.",
      "Draw up the provisional budget and submit it to the GA for a vote.",
      "Keep the union's accounts (separate funds, dedicated account) and present them.",
      "Convene the general assembly, prepare the agenda and communicate the minutes.",
      "Represent the union in civil acts and in court.",
      "Collect charges, track arrears and organize recovery (after conciliation).",
      "Keep the union's documents and hand over the full file to the successor.",
    ],
    ag: [
      "The general assembly is the sovereign body of the co-ownership.",
      "An ordinary GA must be held at least once a year to approve the accounts and vote the budget.",
      "The notice is sent at least 15 days before the meeting: date, time, place and agenda.",
      "Decisions are notified to all co-owners within 8 days (minutes attached).",
      "Since law 30-24, one or more co-owners may themselves convene the GA if needed.",
    ],
    majorities: [
      { level: "Absolute majority", desc: "Day-to-day management of the building and enforcement of the regulations (votes of those present or represented)." },
      { level: "Three-quarters majority", desc: "Drafting or amending the regulations, improvement works, appointment or revocation of the syndic, revision of charge allocation." },
      { level: "Unanimity", desc: "Decisions affecting the substance of the building: new buildings, sale of common areas, converting common to private areas, raising, excavation, or full demolition." },
    ],
    quorum_note: "Quorum: at least half of the co-owners (present or represented). Failing that, a second GA may be held within 30 days and deliberate with no quorum requirement.",
    conseil: "The syndical council assists the syndic and oversees its management. It links co-owners and the syndic, gives its opinion on co-ownership matters and may consult all documents. Its role was strengthened by law 106-12.",
    reglement: [
      "The co-ownership regulations are MANDATORY for any building under co-ownership.",
      "They set the purpose of the building and of the private and common areas.",
      "They define the conditions of use of private and common areas.",
      "They set the rules for administering the common areas.",
      "They determine each lot's share (tantièmes) and the allocation of charges.",
      "They serve as the basis for calculating votes at the general assembly.",
    ],
    conciliation: [
      "Since law 30-24, a formal and documented conciliation attempt is MANDATORY before any legal action by the syndic.",
      "Without this step, the court declares the action inadmissible.",
      "Concerned in particular: unpaid charges, unauthorized works, misuse of common areas, and breaches of the regulations.",
    ],
    checklist: [
      "A written set of co-ownership regulations exists and is accessible to all co-owners.",
      "An ordinary general assembly is held at least once a year.",
      "GA notices are sent at least 15 days in advance with the agenda.",
      "GA minutes are notified to everyone within 8 days.",
      "A syndic is appointed by the GA and a syndical council is in place.",
      "Accounts are kept transparently (dedicated account, supporting documents).",
      "Each lot's shares (tantièmes) are defined and known.",
      "A conciliation attempt is made before any legal action.",
    ],
    disclaimer: "This information is provided for educational purposes to help the \"Rahma Bat A\" co-ownership stay compliant. It is not legal advice and does not replace consulting a notary, an adoul or a lawyer. When in doubt, refer to the official text of laws 18-00, 106-12 and 30-24 and consult a legal professional.",
    reglementTemplate: {
      title: "Co-ownership regulations — Rahma Bat A",
      body: `CO-OWNERSHIP REGULATIONS
Building "Rahma Bat A" — 34 Avenue Meki Naciri, Tétouan
Drawn up in accordance with law No. 18-00 on the status of co-ownership of built properties, as amended and supplemented by laws 106-12 and 30-24.

TITLE I — DESIGNATION
Article 1 — The building "Rahma Bat A" comprises 11 dwellings (9 duplexes and 2 apartments) spread over several floors and served by a lift.
Article 2 — Common areas: the entrance hall, stairwell, landings, lift, terrace (stah / roof) and the caretaker's lodge, for the use of all co-owners.
Article 3 — Private areas: each dwelling (lot) is the exclusive property of its co-owner.

TITLE II — PURPOSE
Article 4 — The building is mainly for residential use. Any change of a lot's purpose must comply with the law and not disturb the building's peace.

TITLE III — SHARES (TANTIÈMES) AND CHARGES
Article 5 — Each lot is assigned a share of the common areas (tantièmes), determining voting weight at the GA and the allocation of charges. Each lot's shares are annexed to these regulations.
Article 6 — Rahma Bat A specificity: the building's running charges are covered by the quarterly rent paid by the operator of the relay antenna installed on the terrace. Co-owners therefore pay no ordinary contribution, unless the GA decides otherwise (exceptional works, insufficient income).
Article 7 — Every expense is published in real time in the app's transparency feed.

TITLE IV — ADMINISTRATION
Article 8 — Co-owners are grouped into a co-owners' union with legal personality, whose purpose is to preserve the building and administer the common areas.
Article 9 — The union is administered by the general assembly and managed by an elected syndic, assisted by a syndical council.

TITLE V — GENERAL ASSEMBLY
Article 10 — The ordinary general assembly meets at least once a year to approve the accounts and vote the budget.
Article 11 — The notice is sent at least 15 days in advance and states the date, time, place and agenda.
Article 12 — Quorum is reached when at least half of the co-owners are present or represented. Failing that, a second assembly is held within 30 days and deliberates with no quorum requirement.
Article 13 — Decisions are taken: by absolute majority for day-to-day management; by three-quarters majority for amending the regulations, improvement works, and appointing or revoking the syndic; by unanimity for decisions affecting the substance of the building.
Article 14 — The assembly's decisions are notified to all co-owners within 8 days, with the minutes attached.

TITLE VI — SYNDIC AND SYNDICAL COUNCIL
Article 15 — The syndic enforces the regulations and GA decisions, administers and maintains the building, keeps the accounts, convenes the GA and represents the union.
Article 16 — The syndical council assists and oversees the syndic and links with the co-owners.

TITLE VII — DISPUTES AND CONCILIATION
Article 17 — In accordance with law 30-24, any legal action by the syndic must be preceded by a formal and documented conciliation attempt; failing that, the action is inadmissible.

TITLE VIII — MISCELLANEOUS
Article 18 — Everyone ensures the building's peace, cleanliness and safety.
Article 19 — These regulations are binding on all co-owners, tenants and occupants.

Adopted by the general assembly on ____ / ____ / ________.
The President (syndic): ____________________`,
    },
  },
};
